import styled from 'styled-components';
import { ImagePartial } from '../../../partials';
import { colours, media, spacing } from '../../../stylings';
import { ProductMoreColorsSingleAndMultiImage } from '../commonStylesForCarouselItem';

export const ProductItemContainer = styled.div`
  position: relative;
`;
export const ProductItemInfo = styled.div`
  margin-top: 90px;
  width: 100%;

  @media ${media.greaterThan('lg')} {
    display: flex;
    gap: ${spacing.XXS};
    justify-content: center;
    margin-top: 150px;
  }
`;
export const ProductMultiImageContainer = styled.div`
  position: relative;
`;
export const ProductThumbnailSelector = styled.div`
  bottom: 0;
  display: flex;
  gap: ${spacing.XXXS};
  left: 0;
  margin: 0 auto;
  position: absolute;
  right: 0;
  top: 103%;
  width: fit-content;
`;
export const ProductThumbnail = styled.div`
  border: 1px solid ${colours.MID_GREY};
  cursor: pointer;
  height: 70px;
  position: relative;
  width: 70px;

  @media ${media.greaterThan('lg')} {
    height: 130px;
    width: 130px;
  }
`;
export const ProductMoreColors = styled.a`
  color: ${colours.BLACK};
  ${ProductMoreColorsSingleAndMultiImage}
`;
export const CarouselImagePartial = styled(ImagePartial)`
  margin-bottom: ${spacing.XXXXXS};
`;
export const Price = styled.div`
  margin-bottom: ${spacing.S};
  position: relative;

  & .now-price,
  & .was-price,
  & .then-price,
  & .price-range {
    font-size: 16px;
    line-height: 18px;
  }
`;
